import { screenSmMin } from '@spotify-internal/encore-foundation';
import styled, { css } from 'styled-components';
import { cssColorValue, semanticColors } from "../../styles/index.js";
import { IconChevronDown } from "../Icon/icons/IconChevronDown/index.js";
var screenSmMinIconSize = 32;
export var AccordionIcon = styled(IconChevronDown).withConfig({
  displayName: "Icon__AccordionIcon",
  componentId: "sc-j3ofo4-0"
})(["@media (min-width:", "){block-size:", "px;inline-size:", "px;}transition:transform 150ms;color:", ";flex-shrink:0;", ";"], screenSmMin, screenSmMinIconSize, screenSmMinIconSize, cssColorValue(semanticColors.textSubdued), function (props) {
  return props.isExpanded && css(["transform:rotate(180deg);"]);
});